export const TOOLTIP_OPEN_DELAY = 50;

export const TOOLTIP_CLOSE_DELAY = 200;
